<script lang="ts">
import { defineComponent } from 'vue'

import FXSelector from '@/components/atoms/FXSelector.vue'
import SnapshotButton from '@/components/atoms/SnapshotButton.vue'
import { useStoreSnapshot } from '@/webgl/composables/useStoreSnapshot'

export default defineComponent({
  name: 'FilterSettings',
  components: {
    SnapshotButton,
    FXSelector
  },
  props: {
    //
  },
  setup () {
    const { button } = useStoreSnapshot()

    return {
      button
    }
  }
})
</script>

<template>
  <div class="wrapper-settings absolute flex flex-col gap-8 items-center bottom-10 left-1/2 transform -translate-x-1/2">
    <FXSelector />
    <SnapshotButton :disabled="false" />
  </div>
</template>

<style lang="scss" scoped>
.wrapper-settings {
  z-index: $z-modal;
}
</style>
